
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';


const _identity_DashboardControllerHelper = new Map<string, Object>();
_identity_DashboardControllerHelper.set('Index', DashboardElementModel);
_identity_DashboardControllerHelper.set('Create', DashboardElementModel);
_identity_DashboardControllerHelper.set('Update', DashboardElementModel);


export const identity_DashboardControllerHelper = _identity_DashboardControllerHelper;

